var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.25,
    width: 34.5,
    height: 23.5,
    rx: 2.75,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.025 8.5L3.75 15.747h3.92l.486-1.156h1.111l.486 1.156h4.315v-.882l.385.882h2.232l.384-.9v.9h8.975l1.09-1.126 1.023 1.126 4.609.01-3.285-3.613L32.766 8.5h-4.538l-1.062 1.105-.99-1.105h-9.763l-.838 1.87-.858-1.87h-3.912v.852L10.37 8.5H7.025zm13.4 1.029h5.154l1.576 1.703 1.627-1.703h1.577l-2.395 2.614 2.395 2.583H28.71l-1.576-1.722-1.636 1.722h-5.073V9.529zm1.273 2.026v-.95h3.216l1.403 1.518-1.465 1.526h-3.154v-1.036h2.812v-1.058h-2.812zM7.783 9.529h1.911l2.172 4.914V9.53h2.094l1.677 3.523 1.546-3.523h2.083v5.2H18l-.01-4.075-1.848 4.075h-1.134l-1.858-4.075v4.075h-2.607l-.495-1.166h-2.67l-.493 1.165H5.487l2.296-5.199zm.05 2.957l.88-2.077.879 2.076H7.833z",
    fill: "#fff"
  })));
}
export default SvgAmex;